/*
 * Copyright (c) 2013 SGS Europe. All rights reserved.
 *
 * This program is the CONFIDENTIAL and PROPRIETARY property of 2013 SGS Europe.
 * Any unauthorised use, reproduction, or transfer of this program is strictly
 * prohibited.
 *
 * File Name:	SGSJQueryExtends.js
 *
 * Description:	Contains any extensions to the JQuery source.
 *
 * History:		08-MAY-13	S Brown		Initial implementation.
 *				04-SEP-18	J Jackson	Added findfirst as a more optimized grep for single items.
 *				18-FEB-19	J Jackson	Added findindex to allow for IndexOf searches. 
 *				19-MAR-19	J Jackson	Added groupby which mirrors LINQ's functionality (without deferred execution..).
 *				29-APR-19	J Jackson	Added uniquify to allow for removing duplicates from arrays.
 *				11-FEB-20	J Morris	Added replaceAll for replacing all occurrences in a string.
 */


/*
 *	AJAX Extensions.
 */


$.postJSON = function (url, data, callback) {
	return jQuery.post(url, data, callback, "json")
		//.done(function () { alert("second success"); })
		//.fail(function (xhr, textStatus, errorThrown) { alert("Failed: " + errorThrown.statusText + " - " + textStatus);})
		.fail(function () { window.setTimeout(callback, 100); });
	//.always(function () { window.setTimeout(callback, 100); });
};


/*
 *	DOM Extensions.
 */

$.fn.exists = function () {
	return this.length !== 0;
};

/*
 * Extend the JQuery library.
 */
$.extend({
	/**
	 * Adds findfirst to Jquery, essentially a more optimized 
	 * $.grep when you are doing a search for a single element.
	 * @param {[]} array An array to search.
	 * @param {Object} func comparison function i.e. function(array) { return array.id === id; }
	 * @returns {any} key
	 */
	findfirst: function (array, func) {
		for (var i = 0; i < array.length; ++i) {
			if (func(array[i], i)) {
				return array[i];
			}
		}
		// not found - do not change.
		return undefined;
	},

	/**
	 * Adds findindex to Jquery, it's an IndexOf() for a condition. 
	 * @param {[]} array An array to search.
	 * @param {Object} func comparison function i.e. function(array) { return array.id === id; }
	 * @returns {number} first index of.
	 */
	findindex: function (array, func) {
		for (var i = 0; i < array.length; ++i) {
			if (func(array[i], i)) {
				return i;
			}
		}
		// not found - do not change.
		return undefined;
	},

	/**
	 * Groups an array into sub arrays based on a property.
	 * @param {[]} array Array to group.
	 * @param {string} property Property to group by. 
	 * @returns {[]} An array with sub-arrays.
	 */
	groupBy: function (array, property) {
		var grouped = array.reduce(function (accumlator, currentValue) {
			var key = currentValue[property];
			if (!accumlator[key]) {
				accumlator[key] = [];
			}
			accumlator[key].push(currentValue);
			return accumlator;
		}, {});

		var properties = Object.getOwnPropertyNames(grouped).sort();

		return properties.map(function (property) {
			return grouped[property];
		});
	},

	/**
	 * Maps an array of objects to a specified property.
	 * @param {[]} array Array to map from.
	 * @param {string} property Items to remove.
	 * @returns {[]} New mapped array created from the property.
	*/
	propertyMap: function (array, property) {
		return array.map(function (value) {
			return value[property];
		});
	},

	/**
	* .Find equiv. matched to a specified property.
	 * @param {[]} array Array to search
	 * @param {Object} obj comparison object
	 * @param {string} property property to match on
	 * @returns {Object} First match via property.
	*/
	findByProp: function (array, obj, property) {
		return $.findfirst(array, function (value) {
			return value[property] === obj[property];
		});
	},

	/**
	 * Removes items in an array from another.
	 * @param {[]} array Array to remove from.
	 * @param {[]} commons Items to remove.
	 * @returns {[]} New filtered array with the other arrays items removed.
	 */
	dropCommons: function (array, commons) {
		if (!commons.length)
			return array;

		return array.filter(function (val) {
			return commons.indexOf(val) === -1;
		});
	},

	/**
	 * Gets shared items between two arrays.
	 * @param {[]} array1 Array to compare.
	 * @param {[]} array2 Array to compare.
	 * @returns {[]} New array with common tasks.
	 */
	getCommons: function (array1, array2) {
		return array1.filter(function (val) {
			return array2.indexOf(val) !== -1;
		});
	},

	/**
	 * Appends values & eliminates duplicates from an array.
	 * @param {[]} array Array to remove duplicates from.
	 * @returns {[]} New copy of array with duplicates removed.
	 */
	appendUniquify: function (array1, array2) {
		var copy = array1.slice();
		copy.push.apply(copy, array2);
		return $.uniquify(copy);
    },

	/**
	 * Eliminates duplicates from an array.
	 * @param {[]} array Array to remove duplicates from.
	 * @returns {[]} New copy of array with duplicates removed.
	 */
	uniquify: function (array) {
		return array.filter(function (val, index) {
			return array.indexOf(val) === index;
		});
	},

	distinctBy: function (array, prop) {
		return array.filter(function (val, index, arr) {
			for (var i = 0; i < index; i++) {
				if (arr[i][prop] === val[prop])
					return false;
            }

			return true;
		});
    },

	/**
	 * Inserts an element into the array at the given index.
	 * @param {[]} arr - The array to insert to.
	 * @param {number} index - The index to insert at.
	 * @param {Object} newItem - The element to insert.
	 */
	insertAt: function (arr, index, newItem) {
		// part of the array before the specified index
		var items = arr.slice(0, index);
		items.push(newItem);
		items.push.apply(items, arr.slice(index));

		return items;
	},

	/**
	 * Replace all occurences of a value in a string
	 * @param {string} originalValue - The original string value.
	 * @param {string} searchValue - The value to find.
	 * @param {string} replaceValue - The value to replace with.
	 */
	replaceAll: function (originalValue, searchValue, replaceValue) {
		return originalValue.split(searchValue).join(replaceValue);
	}
});